import { Button, ForwardToInboxOutlinedIcon } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { SearchUsersByAppRoleFiltersDocument } from '@user-management/graphql';

import { useResendUserInvitationEmail } from '../../hooks';

interface ResendEmailInvitationProps {
  userId: string;
}

export default function ResendEmailInvitationButton(props: Readonly<ResendEmailInvitationProps>) {
  const { userId } = props;
  const { showPromiseSnackbar } = useSnackbar();

  const { resendUserInvitationEmail, isResendingPasswordResetEmail } = useResendUserInvitationEmail(
    {
      userId,
      refetchQueries: [SearchUsersByAppRoleFiltersDocument],
      awaitRefetchQueries: true,
    },
  );

  const handleResendEmailInvitation = () => {
    showPromiseSnackbar({
      promise: resendUserInvitationEmail,
      message: {
        pending: 'Sending invitation',
        success: 'User invited successfully',
        error: 'Cannot send invitation',
      },
    });
  };

  return (
    <Button
      variant='outlined'
      size='small'
      startIcon={<ForwardToInboxOutlinedIcon />}
      onClick={handleResendEmailInvitation}
      loading={isResendingPasswordResetEmail}
    >
      Resend Invitation
    </Button>
  );
}
